module.exports = __webpack_public_path__ + "static/media/favicon.5a87be72.ico";